(async () => {

  if (!customElements.get('instagram-slider-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class InstagramSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-instagram-slider]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          direction: 'horizontal',
          watchSlidesProgress: true,
          spaceBetween: 16,
          breakpoints: {
            360: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }

        this.checkInstagram();

      }

      checkInstagram() {

        let that = this;
        let instaFeed = document.getElementById('insta-feed').innerHTML;

        if (instaFeed.length > 0) {
          setTimeout(function() {
            that.init();
          }, 250);
        } else {
          setTimeout(function() {
            that.checkInstagram();
          }, 250);
        }
      }

      init() {

        let slideArr = this.swiperElement.querySelectorAll('a');
        slideArr.forEach(function(slide){
          slide.classList.add('swiper-slide');
        });

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.InstagramSlider = InstagramSlider;

    customElements.define('instagram-slider-swiper', InstagramSlider);

  }

})();
